import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect } from 'react';
import * as DialogStyles from '../views/Dialog.scss';
export default function TemplateDialog(props) {
    var _a, _b, _c;
    const { children, closeButton, handleSelected, Styles } = props;
    useStyles(DialogStyles, Styles);
    // Add backbutton & escape button event listeners.
    useEffect(() => {
        window.addEventListener('keydown', handleKeydown);
        return () => {
            window.removeEventListener('keydown', handleKeydown);
        };
    }, []);
    // dialog styles can be passed/edited from parent
    const modalClass = (_a = Styles === null || Styles === void 0 ? void 0 : Styles.modal) !== null && _a !== void 0 ? _a : DialogStyles.modal;
    const modalContentClass = (_b = Styles === null || Styles === void 0 ? void 0 : Styles.modalContent) !== null && _b !== void 0 ? _b : DialogStyles.modalContent;
    const closeButtonClass = (_c = Styles === null || Styles === void 0 ? void 0 : Styles.closeButtonContainer) !== null && _c !== void 0 ? _c : DialogStyles.closeButtonContainer;
    return (React.createElement("div", { className: modalClass, role: "dialog", "aria-modal": "true", "aria-labelledby": "dialogHeader", "aria-describedby": "dialogBodyText", id: "dialog" },
        React.createElement("div", { className: modalContentClass },
            renderCloseButton(),
            children)));
    function renderCloseButton() {
        if (!closeButton) {
            return null;
        }
        return (React.createElement("div", { className: closeButtonClass, id: "dialogCloseButton" },
            React.createElement("music-button", { role: "button", variant: "glass", size: "small", "icon-only": true, "icon-name": closeButton.icon, tabIndex: 3, onmusicActivate: handleSelected.bind(this, closeButton.primaryLink.onItemSelected) })));
    }
    function handleKeydown(e) {
        switch (e.key) {
            case 'Escape':
                if (closeButton) {
                    handleSelected(closeButton.primaryLink.onItemSelected, e);
                }
                break;
            default:
                break;
        }
    }
}
